import { Alert, Autocomplete, Box, Button, Chip, Container, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import useGlobal from "./useGlobal";
import MaterialTable from "material-table";
import { Pool, Download, Edit, Cancel } from "@mui/icons-material";
import Swal from "sweetalert2";

function escapeHtml(str) {
    return String(str ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
}

function oeffneDruckFenster(scheine) {
    if (!scheine || !scheine.length) return;
    const printWindow = window.open('', '_blank', 'width=900,height=900');
    if (!printWindow) {
        alert('Druck-Fenster blockiert. Bitte Pop-ups für diese Seite erlauben.');
        return;
    }
    const renderSchein = (s, isLast) => {
        const kurzId = (s._id || '').toString().slice(0, 8);
        const vollId = (s._id || '').toString();
        const datum = s.datum || '';
        const showAbholer = s.abholer && s.abholer !== s.mitarbeiter;
        const rowsHtml = (s.bestellungen_snapshot || []).map(b => `
            <tr>
                <td>${escapeHtml(b.produkt)}</td>
                <td>${b.variante ? escapeHtml(b.variante) : '—'}</td>
                <td style="text-align:center">${b.anzahl || 1}</td>
                <td>${escapeHtml(b.customize)}</td>
                <td>${escapeHtml(b.custom_color)}</td>
            </tr>
        `).join('');
        const breakClass = isLast ? '' : 'page-break';
        return `
<div class="schein ${breakClass}">
  <h1>Abholschein AS-${escapeHtml(kurzId)}</h1>
  <div class="meta">
    <div>Datum: ${escapeHtml(datum)}</div>
    <div>Ausgegeben durch: ${escapeHtml(s.ausgegeben_von || '')}</div>
  </div>
  <p>Mitarbeiter: <b>${escapeHtml(s.mitarbeiter_klarname || s.mitarbeiter || '')}</b></p>
  ${showAbholer ? `<p class="abholer">Abgeholt durch: <b>${escapeHtml(s.abholer_klarname || s.abholer)}</b></p>` : ''}
  <table>
    <thead><tr><th>Produkt</th><th>Variante</th><th>Anzahl</th><th>Personalisierung</th><th>Farbe</th></tr></thead>
    <tbody>${rowsHtml}</tbody>
  </table>
  <div class="unterschrift">
    <p>Hiermit bestätige ich den Erhalt obiger Ware.</p>
    <p>Datum, Unterschrift:</p>
    <div class="unterschrift-line"></div>
  </div>
  <div class="footer">Schein-ID: ${escapeHtml(vollId)}</div>
</div>`;
    };
    const html = `<!DOCTYPE html>
<html lang="de">
<head>
<meta charset="UTF-8">
<title>Abholscheine</title>
<style>
  body { font-family: sans-serif; margin: 20mm; font-size: 11pt; }
  h1 { font-size: 16pt; margin: 0 0 4mm; }
  .meta { display: flex; justify-content: space-between; margin: 0 0 6mm; }
  .abholer { color: #b58105; font-weight: bold; }
  table { width: 100%; border-collapse: collapse; margin-top: 4mm; }
  thead { display: table-header-group; }
  tr { page-break-inside: avoid; }
  th, td { border: 1px solid #000; padding: 2mm 3mm; text-align: left; vertical-align: top; }
  th { background: #eee; }
  .unterschrift { margin-top: 18mm; }
  .unterschrift-line { border-bottom: 1px solid #000; height: 18mm; }
  .footer { font-size: 8pt; color: #666; margin-top: 8mm; word-break: break-all; }
  .schein.page-break { page-break-after: always; }
  @media print { body { margin: 15mm; } }
</style>
</head>
<body>
${scheine.map((s, i) => renderSchein(s, i === scheine.length - 1)).join('\n')}
<script>
window.onload = function() {
    setTimeout(function() { window.print(); }, 100);
};
</script>
</body>
</html>`;
    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
}

function DirektEingangDialog({open, onClose, vorbefuellung, offeneBestellungen, onErfolg}) {
    const [axios] = useGlobal('axios');
    const [produkte, setProdukte] = useState([]);
    const [zeilen, setZeilen] = useState([]);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        if (!open || !axios) return;
        axios.get('produktliste').then(r => setProdukte(r.data || []));
        setZeilen(vorbefuellung || []);
    }, [open, axios, vorbefuellung]);

    const updateGeliefert = (idx, val) => {
        const num = val === '' ? 0 : parseInt(val, 10);
        if (Number.isNaN(num)) return;
        setZeilen(zeilen.map((z, i) => i === idx ? {...z, geliefert: num} : z));
    };

    const removeZeile = (idx) => {
        setZeilen(zeilen.filter((_, i) => i !== idx));
    };

    const fuegeProdukteHinzu = (produkt) => {
        if (!produkt) return;
        const exists = zeilen.findIndex(z =>
            z.produkt === produkt.produkt && (z.variante || '') === (produkt.variante || '')
        );
        if (exists >= 0) return;
        const liste = offeneBestellungen || [];
        const parent = liste.find(p =>
            !p._id && p.produkt === produkt.produkt && (p.variante || '') === (produkt.variante || '')
        );
        const childIds = parent
            ? liste.filter(b => b.parentId === parent.id && b._id).map(b => b._id)
            : [];
        setZeilen([...zeilen, {
            produkt: produkt.produkt,
            variante: produkt.variante || '',
            bestellt: childIds.length,
            geliefert: Math.max(childIds.length, 1),
            bestellung_ids: childIds,
        }]);
    };

    const ungueltig = zeilen.filter(z => z.geliefert <= 0);
    const summeExtra = zeilen.reduce((s, z) => s + Math.max(0, z.geliefert - z.bestellt), 0);
    const summeOffen = zeilen.reduce((s, z) => s + Math.max(0, z.bestellt - z.geliefert), 0);

    const buchen = () => {
        if (ungueltig.length) {
            Swal.fire({icon:'error', title:'Ungültige Anzahl', text:'Geliefert muss > 0 sein.'});
            return;
        }
        setBusy(true);
        axios.post('direkteingang', {zeilen}).then(r => {
            setBusy(false);
            Swal.fire({icon:'success', title:'Eingang verbucht', timer:1500, showConfirmButton:false});
            onErfolg();
            onClose();
        }).catch(err => {
            setBusy(false);
            const liste = err?.response?.data?.fehler;
            if (liste) {
                Swal.fire({icon:'error', title:'Verbuchen nicht möglich', html: liste.map(f => `${f.produkt || f.bestellung_id || ''}: ${f.grund}`).join('<br/>')});
            } else {
                Swal.fire({icon:'error', title:'Fehler', text: err?.message || 'Unbekannter Fehler'});
            }
        });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Direkt-Eingang erfassen</DialogTitle>
            <DialogContent>
                <Box sx={{marginTop:2, marginBottom:2}}>
                    <Autocomplete
                        options={produkte}
                        getOptionLabel={(o) => o.label || ''}
                        isOptionEqualToValue={(a,b) => a.produkt === b.produkt && a.variante === b.variante}
                        filterOptions={(opts, {inputValue}) => {
                            const q = (inputValue || '').toLowerCase().trim();
                            if (!q) return opts.slice(0, 50);
                            return opts.filter(o =>
                                o.produkt.toLowerCase().includes(q) ||
                                (o.variante || '').toLowerCase().includes(q) ||
                                (o.label || '').toLowerCase().includes(q)
                            ).slice(0, 50);
                        }}
                        renderInput={(params) => <TextField {...params} label="Artikel suchen + hinzufügen" />}
                        onChange={(e, value) => fuegeProdukteHinzu(value)}
                        value={null}
                        blurOnSelect
                        clearOnBlur
                    />
                </Box>
                {!zeilen.length && (
                    <Typography variant="body2" sx={{color:'#666', marginTop:2}}>
                        Keine Zeilen. Über die Suche oben Artikel hinzufügen oder Dialog mit Vorab-Selektion in der Tabelle erneut öffnen.
                    </Typography>
                )}
                {!!zeilen.length && (
                    <table className="inventur-tabelle" style={{marginTop:8}}>
                        <thead>
                            <tr>
                                <th>Produkt</th>
                                <th>Variante</th>
                                <th>Bestellt</th>
                                <th>Geliefert</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {zeilen.map((z, idx) => {
                                const fehler = z.geliefert <= 0;
                                return (
                                    <tr key={`${z.produkt}|${z.variante}`} style={fehler ? {backgroundColor:'#ffe4e4'} : {}}>
                                        <td>{z.produkt}</td>
                                        <td>{z.variante || '—'}</td>
                                        <td style={{textAlign:'center'}}>{z.bestellt}</td>
                                        <td style={{width:90}}>
                                            <TextField size="small" type="number" value={z.geliefert}
                                                onChange={e => updateGeliefert(idx, e.target.value)}
                                                inputProps={{min: 0}}/>
                                        </td>
                                        <td style={{textAlign:'center'}}>
                                            {z.bestellt === 0 && (
                                                <IconButton size="small" onClick={() => removeZeile(idx)}>
                                                    <Cancel fontSize="small"/>
                                                </IconButton>
                                            )}
                                            {z.geliefert < z.bestellt && (
                                                <Typography variant="caption" sx={{color:'#b26500'}}>
                                                    Teil
                                                </Typography>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
                {summeExtra > 0 && (
                    <Box sx={{marginTop:2, padding:2, backgroundColor:'#fff3cd', border:'1px solid #ffeaa7'}}>
                        Es werden <b>{summeExtra}</b> zusätzliche POOL-Bestellung(en) angelegt.
                    </Box>
                )}
                {summeOffen > 0 && (
                    <Box sx={{marginTop:2, padding:2, backgroundColor:'#ffe4e4', border:'1px solid #f5b5b5'}}>
                        Teillieferung: <b>{summeOffen}</b> Bestellung(en) bleiben offen. Die ältesten werden zuerst bedient (FIFO).
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={busy}>Abbrechen</Button>
                <Button variant="contained" disabled={busy || !zeilen.length || ungueltig.length > 0} onClick={buchen}>
                    Eingang verbuchen
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export function BestellEingang({status}){
    const [axios,setAxios] = useGlobal('axios')
    const [permissions,setPermissions] = useGlobal('permissions',[])
    const [bestellungen,setBestellungen] = useState([])
    const [bfilter,setBfilter] = useState([])
    const [activeFilter,setActiveFilter] = useState(false)
    const [checkedrows,setCheckedrows] = useState([])
    const [fullrows,setFullrows] = useState(false)
    const [lieferanten,setLieferanten] = useState([])
    const [direktDialogOpen, setDirektDialogOpen] = useState(false);
    const [direktVorbefuellung, setDirektVorbefuellung] = useState([]);



    useEffect(() => {
        getData()
    },[])

    const getData = () => {
        const params = {status:status,fullset:true}
        axios.get('bestellungen',{params}).then(result => {
            setActiveFilter(false)
            setBestellungen(result.data)
            setLieferanten([...new Set(result.data.map(item => item.lieferant))])
        })
    }

    useEffect(() => {
        setBfilter(bestellungen)
    },[bestellungen])

    const expandChange = (e,n) => {
        setFullrows(n)
    }

    const selectionChange = (rows) => {
        const ids = new Set();
        for (const r of rows) {
            if (r._id) {
                ids.add(r._id);
            } else if (r.id !== undefined) {
                for (const b of bestellungen) {
                    if (b.parentId === r.id && b._id) ids.add(b._id);
                }
            }
        }
        setCheckedrows([...ids]);
    }

    const toggleFilter = (l) => {
        if (l) {
            setBfilter(bestellungen.filter(b => b.lieferant == l))
        } else {setBfilter(bestellungen)}
        setActiveFilter(l)
    }

    const changeStatus = (newstatus) => {
        axios.post('statuschange',{ids:checkedrows,newstatus:newstatus}).then(result => getData())
    }

    const takefrompool = (row) => {
        console.log(row)
        axios.post('auspoolliefern',{row:row}).then(result => getData())
    }

    const oeffneDirektDialog = () => {
        const grouped = {};
        for (const id of checkedrows) {
            const b = bestellungen.find(x => x._id === id);
            if (!b) continue;
            const key = `${b.produkt}|${b.variante || ''}`;
            if (!grouped[key]) {
                grouped[key] = {
                    produkt: b.produkt,
                    variante: b.variante || '',
                    bestellung_ids: [],
                };
            }
            grouped[key].bestellung_ids.push(id);
        }
        const vorbefuellung = Object.values(grouped).map(g => ({
            ...g,
            bestellt: g.bestellung_ids.length,
            geliefert: g.bestellung_ids.length,
        }));
        setDirektVorbefuellung(vorbefuellung);
        setDirektDialogOpen(true);
    };

    const exportSelectedData = () => {
        const exportColumns = [
            { title: 'Produkt', field: 'produkt' },
            { title: 'Variante', field: 'variante' },
            { title: 'Personalisierung', field: 'customize' },
            { title: 'Personalisierung Farbe', field: 'custom_color' },
            { title: 'Anzahl', field: 'anzahl' }
        ];
        
        const exportData = bfilter.map(row => ({
            produkt: row.produkt,
            variante: row.variante || '',
            customize: row.customize || '',
            custom_color: row.custom_color || '',
            anzahl: row.anzahl || 1
        }));

        const csvContent = [
            exportColumns.map(col => col.title).join(','),
            ...exportData.map(row => 
                exportColumns.map(col => `"${row[col.field] || ''}"`).join(',')
            )
        ].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'Bestellung.csv';
        link.click();
    };

    return (
        <Container sx={{minHeight:'50vh'}}>
        <Container>
        {!!lieferanten.length && 
            <>
            <Typography variant="h5">Filter nach Lieferant</Typography>
            {lieferanten.map(l => 
                <Button key={'button_'+l} onClick={e => toggleFilter(l)} variant={l === activeFilter ? 'contained' : 'outlined'}>{l}</Button>
            )}
             <Button key={'button_clear'} onClick={e => toggleFilter(false)} variant={'outlined'}>Filter löschen</Button>
            </>
        }
        </Container>
            {status === 1 && (
                <Box sx={{margin:'10px 0'}}>
                    <Button variant="contained" color="secondary" onClick={oeffneDirektDialog}>
                        Direkt-Eingang erfassen
                    </Button>
                </Box>
            )}
            <DirektEingangDialog
                open={direktDialogOpen}
                onClose={() => setDirektDialogOpen(false)}
                vorbefuellung={direktVorbefuellung}
                offeneBestellungen={bestellungen}
                onErfolg={() => getData()}
            />
            {!!bfilter.length && <MaterialTable
                title="Bestellungen"
                localization={{
                    pagination: {
                        labelDisplayedRows: '{from}-{to} von {count}',
                        labelRowsPerPage: 'Zeilen pro Seite',
                        labelRowsSelect : 'Zeilen'
                    },
                    toolbar: {
                        nRowsSelected: '{0} Reihen ausgewählt',
                        searchPlaceholder: 'Suche'
                    },
                    header: {
                        actions: 'Aktionen'
                    },
                    
                    body: {
                        emptyDataSourceMessage: 'Keine Daten zum Anzeigen',
                        editRow : {
                            deleteText : 'Sicher löschen?'
                        }
                    }
                }}
                columns={[
                    { title: 'Produkt', field: 'produkt', },
                    { title: 'Variante', field: 'variante',render: rowData => rowData.variante ? rowData.variante : '' },
                    { title: 'Personalisierung', field: 'customize',hidden:!fullrows,render: rowData => rowData.customize ? rowData.customize : '' },
                    { title: 'Personalisierung Farbe', field:'custom_color',hidden:!fullrows,render: rowData => rowData.custom_color ? rowData.custom_color : ''},
                    { title: 'Lieferant', field: 'lieferant',hidden:fullrows },
                    { title: 'Anzahl', field:'anzahl', render: rowData => rowData?.anzahl ? rowData.anzahl : 1},
                    { title: 'Lagernd', field:'poolitems', render: rowData =>rowData?.poolitems && rowData?.poolitems.length ? rowData?.poolitems.length: ''},
                    { title: 'aus Pool bedienen', field:'poolitems', hidden: !fullrows, 
                        render: rowData => rowData?.poolitems && rowData?.poolitems.length && rowData._id && (rowData?.user !== 'POOL') ? <Pool onClick={e => takefrompool(rowData)}/> : ''},
                    {title:'User',field:'user',hidden:!fullrows},
                    {title:'Bestelldatum',field:'bestelldatum',hidden:!fullrows}
                ]}

                options={{
                    selection: true,
                    exportButton: false,
                    pageSize: 10,
                    actionsColumnIndex: -1
                }}
                onSelectionChange={(rows) => selectionChange(rows)}
                data={bfilter}
                parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
                onTreeExpandChange={(e,v) => expandChange(e,v)}
                actions={[
                    {
                        icon: Download,
                        tooltip: 'Exportieren',
                        onClick: exportSelectedData,
                        isFreeAction: true
                    }
                ]}
            />}
        <Box sx={{margin: '10px'}}>
        <Button variant="contained" disabled={!checkedrows.length} onClick={e => changeStatus(status+1)}>{status == 0 ? 'markierte Einträge als bestellt markieren' : 'markierte Einträge als eingegangen markieren'}</Button>
        </Box>
        </Container>
    )
}


function VarianteAendernDialog({bestellung, aktuelleAuswahl, onClose}) {
    const [axios] = useGlobal('axios');
    const [varianten, setVarianten] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedKey, setSelectedKey] = useState('');

    useEffect(() => {
        if (!bestellung) return;
        setLoading(true);
        setSelectedKey('');
        axios.get('inventur/variantenverfuegbarkeit', {params:{produkt: bestellung.produkt}}).then(r => {
            setVarianten(r.data.varianten || []);
            setLoading(false);
        });
    }, [bestellung, axios]);

    if (!bestellung) return null;

    // Optionen-Liste: pro Variante ein POOL-Eintrag (wenn POOL>0) plus pro reservierter Bestellung ein eigener Eintrag.
    const optionen = [];
    varianten.forEach(v => {
        const name = v.variante || '(keine)';
        if (v.pool > 0) {
            optionen.push({
                key: `pool|${v.variante}`,
                neue_variante: v.variante,
                quelle_id: undefined,
                istReserviert: false,
                label: `${name}: ${v.pool} frei (POOL)`,
            });
        }
        v.reserviert.forEach(r => {
            optionen.push({
                key: `res|${r._id}`,
                neue_variante: v.variante,
                quelle_id: r._id,
                istReserviert: true,
                reservierterUser: r.user,
                label: `${name}: zurückstellen von ${r.user} (bestellt ${r.bestelldatum || '—'})`,
            });
        });
        if (v.pool === 0 && v.reserviert.length === 0) {
            optionen.push({
                key: `none|${v.variante}`,
                neue_variante: v.variante,
                disabled: true,
                istReserviert: false,
                label: `${name}: nicht lagernd`,
            });
        }
    });

    const aktuelle = optionen.find(o => o.key === selectedKey);
    const istOriginal = aktuelle && aktuelle.neue_variante === (bestellung.variante || '');

    return (
        <Dialog open={!!bestellung} onClose={() => onClose(null)} maxWidth="sm" fullWidth>
            <DialogTitle>Variante ändern für {bestellung.produkt}</DialogTitle>
            <DialogContent>
                {loading && <Typography>lädt Verfügbarkeit...</Typography>}
                {!loading && (
                    <FormControl fullWidth sx={{marginTop:2}}>
                        <InputLabel>Neue Variante</InputLabel>
                        <Select label="Neue Variante" value={selectedKey} onChange={e => setSelectedKey(e.target.value)}>
                            {optionen.map(o => (
                                <MenuItem key={o.key} value={o.key} disabled={!!o.disabled}>
                                    {o.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
                {aktuelle?.istReserviert && (
                    <Alert severity="error" variant="filled" sx={{marginTop:2}}>
                        Die Bestellung von <b>{aktuelle.reservierterUser}</b> wird auf „im Zulauf" zurückgesetzt — sie muss neu beim Hersteller beschafft werden.
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose(null)}>Abbrechen</Button>
                <Button color="warning" onClick={() => onClose({restoreOriginal: true})}>Original beibehalten</Button>
                <Button
                    variant="contained"
                    disabled={!aktuelle || aktuelle.disabled || istOriginal || loading}
                    onClick={() => onClose({neueVariante: aktuelle.neue_variante, quelleId: aktuelle.quelle_id})}
                >
                    Übernehmen
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export function Abholung({}){
    const [axios,setAxios] = useGlobal('axios')
    const [permissions,setPermissions] = useGlobal('permissions',[])
    const [bestellungen,setBestellungen] = useState([])
    const [bfilter,setBfilter] = useState([])
    const [checkedrows,setCheckedrows] = useState([])
    const [fullrows,setFullrows] = useState(false)
    const [users,setUsers] = useState([])
    const [userlabels,setUserlabels] = useState([])
    const [nohit,setNohit] = useState([])
    const [inactiveuser,setInactiveuser] = useState([])
    const [variantenWechsel, setVariantenWechsel] = useState({});
    const [varianteEditFor, setVarianteEditFor] = useState(null);
    const [letzteScheine, setLetzteScheine] = useState([]);


    useEffect(() => {
        //getData()
    },[])

    useEffect(() => {
        if (!axios) return;
        axios.get('userlabels').then(r => setUserlabels(r.data || []));
    }, [axios]);

    const reloadLetzteScheine = () => {
        if (!axios) return;
        const params = users.length ? {user: users[0]} : {};
        axios.get('abholscheine', {params}).then(r => setLetzteScheine(r.data || []));
    };

    useEffect(() => {
        reloadLetzteScheine();
    }, [axios, users]);

    const druckeErneut = (scheinId) => {
        axios.get(`abholscheine/${scheinId}`).then(r => {
            if (r.data && r.data._id) oeffneDruckFenster([r.data]);
        });
    };

    const storniere = (schein) => {
        const klar = schein.mitarbeiter_klarname || schein.mitarbeiter || '';
        Swal.fire({
            icon: 'warning',
            title: 'Schein wirklich stornieren?',
            html: `Bestellungen von <b>${klar}</b> werden auf "lagernd" zurückgesetzt, der Schein wird als storniert markiert.`,
            showCancelButton: true,
            confirmButtonText: 'Stornieren',
            cancelButtonText: 'Abbrechen',
            confirmButtonColor: '#d33',
        }).then(result => {
            if (!result.isConfirmed) return;
            axios.post(`abholscheine/${schein._id}/storno`).then(r => {
                if (r.data?.uebersprungen?.length) {
                    Swal.fire({
                        icon: 'info',
                        title: 'Schein storniert',
                        html: `${r.data.zurueckgesetzt?.length || 0} Bestellung(en) zurueckgesetzt.<br/>${r.data.uebersprungen.length} uebersprungen (gehoeren bereits zu einem anderen Schein).`,
                    });
                } else {
                    Swal.fire({icon: 'success', title: 'Schein storniert', timer: 1500, showConfirmButton: false});
                }
                reloadLetzteScheine();
                if (users.length) {
                    const params = {fullset:true,'users[]':users};
                    axios.get('abholungen',{params}).then(result => {
                        setBestellungen(result.data.liste || []);
                        setNohit(result.data.nohit || []);
                        setInactiveuser(result.data.inactive || []);
                    });
                }
            }).catch(err => {
                Swal.fire({icon:'error', title:'Storno fehlgeschlagen', text: err?.response?.data?.msg || err?.message || 'Unbekannter Fehler'});
            });
        });
    };

    useEffect(() => {
        if (!users.length) {
            setBestellungen([]);
            setNohit([]);
            setInactiveuser([]);
            return;
        }
        const params = {fullset:true,'users[]':users}
        axios.get('abholungen',{params}).then(result => {
            setBestellungen(result.data.liste || [])
            setNohit(result.data.nohit || [])
            setInactiveuser(result.data.inactive || [])
        })
    },[users])

    const getData = () => {
        const params = {fullset:true}
         axios.get('abholungen',{params}).then(result => {
            setBestellungen(result.data.liste)
        })
    }

    useEffect(() => {
        setBfilter(bestellungen)
    },[bestellungen])

    const expandChange = (e,n) => {
        setFullrows(n)
    }

    const selectionChange = (rows) => {
        const ids = new Set();
        for (const r of rows) {
            if (r._id) {
                ids.add(r._id);
            } else if (r.id !== undefined) {
                // Parent-Aggregat-Zeile: alle zugehoerigen Children einschliessen
                for (const b of bestellungen) {
                    if (b.parentId === r.id && b._id) ids.add(b._id);
                }
            }
        }
        setCheckedrows([...ids]);
    }


    const changeStatus = (newstatus) => {
        axios.post('statuschange',{ids:checkedrows,newstatus:newstatus,taker:false}).then(result => getData())
    }

    const handout = () => {
        const newstatus = 3
        const wechsel = checkedrows
            .filter(id => variantenWechsel[id] !== undefined)
            .map(id => ({
                bestellung_id: id,
                neue_variante: variantenWechsel[id].neue_variante,
                quelle_id: variantenWechsel[id].quelle_id,
            }));
        const showFehler = (fehler) => {
            Swal.fire({
                icon: 'error',
                title: 'Aktion nicht möglich',
                html: 'Folgende Probleme:<br/>'
                    + fehler.map(f => `<b>${f.bestellung_id || ''}</b>: ${f.grund}`).join('<br/>'),
            });
        }
        axios.post('statuschange',{
            ids:checkedrows,
            newstatus:newstatus,
            abholer:users[0],
            varianten_aenderungen:wechsel,
        }).then(result => {
            if (result.data && result.data.fehler) {
                showFehler(result.data.fehler);
                return Promise.reject('handled');
            }
            const bestellungenById = Object.fromEntries(bestellungen.filter(b => b._id).map(b => [b._id, b]));
            const proMitarbeiter = {};
            for (const id of checkedrows) {
                const b = bestellungenById[id];
                if (!b) continue;
                const m = b.user;
                (proMitarbeiter[m] ||= []).push(id);
            }
            const scheine = Object.entries(proMitarbeiter).map(([mitarbeiter, ids]) => ({
                mitarbeiter, bestellung_ids: ids,
            }));
            return axios.post('abholscheine', {abholer: users[0], scheine});
        }).then(scheineResult => {
            if (!scheineResult) return;
            if (scheineResult.data && scheineResult.data.fehler) {
                showFehler(scheineResult.data.fehler);
                return;
            }
            oeffneDruckFenster(scheineResult.data.scheine || []);
            setVariantenWechsel({})
            setUsers([])
            setNohit([])
            setInactiveuser([])
            setBestellungen([])
            setCheckedrows([])
        }).catch(err => {
            if (err === 'handled') return;
            const fehler = err?.response?.data?.fehler;
            if (fehler) {
                showFehler(fehler);
            } else {
                Swal.fire({icon:'error', title:'Fehler beim Ausgeben', text: err?.message || 'Unbekannter Fehler'});
            }
        })
    }


    return (
        <Container sx={{minHeight:'50vh'}}>
            <Autocomplete
                multiple
                fullWidth
                options={userlabels}
                value={userlabels.filter(u => users.includes(u.username))}
                getOptionLabel={(o) => o.dienstplan || `${o.vorname} ${o.nachname}`.trim() || o.username}
                isOptionEqualToValue={(o,v) => o.username === v.username}
                filterOptions={(opts, {inputValue}) => {
                    const q = (inputValue || '').toLowerCase().trim();
                    if (!q) return opts;
                    return opts.filter(o =>
                        o.username.toLowerCase().includes(q) ||
                        (o.dienstplan || '').toLowerCase().includes(q) ||
                        (o.vorname || '').toLowerCase().includes(q) ||
                        (o.nachname || '').toLowerCase().includes(q)
                    );
                }}
                onChange={(e, newval) => setUsers((newval || []).map(o => o.username))}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => {
                        const label = option.dienstplan || `${option.vorname} ${option.nachname}`.trim() || option.username;
                        const tagProps = getTagProps({index});
                        return (
                            <Chip
                                {...tagProps}
                                key={option.username}
                                label={index === 0 ? `Abholer: ${label}` : label}
                                color={index === 0 ? 'primary' : 'default'}
                            />
                        );
                    })
                }
                renderInput={(params) => <TextField {...params} label="Abholer + ggf. weitere Mitarbeiter" />}
            />
            {users.length > 1 && (
                <Box sx={{margin:'8px 0', fontSize:'0.95em', color:'#444'}}>
                    Abholer: <b>{userlabels.find(u => u.username === users[0])?.dienstplan || users[0]}</b> — holt zusätzlich für: <b>{users.slice(1).map(u => userlabels.find(x => x.username === u)?.dienstplan || u).join(', ')}</b>
                </Box>
            )}
            {!!nohit.length &&
                <Alert severity="warning" variant="filled">
                    <>Keine abholbereite Ware fuer: <b>{nohit.join(', ')}</b></>
                </Alert>
            }
            {!!inactiveuser.length && inactiveuser.length > 1 &&
            <Alert severity="error" variant="filled">
                <Box>Gesperrte User: <b>{inactiveuser.map(n => <Box>{n}</Box>)}</b></Box>
                <Box>Bitte vor Ausgabe Status klären</Box>
            </Alert>
            }
            <VarianteAendernDialog
                bestellung={varianteEditFor}
                aktuelleAuswahl={varianteEditFor ? variantenWechsel[varianteEditFor._id] : null}
                onClose={(result) => {
                    if (result === null) {
                        // Abbruch: nichts tun
                    } else if (result.restoreOriginal) {
                        setVariantenWechsel(w => {
                            const neu = {...w};
                            delete neu[varianteEditFor._id];
                            return neu;
                        });
                    } else if (result.neueVariante !== undefined) {
                        setVariantenWechsel(w => ({...w, [varianteEditFor._id]: {neue_variante: result.neueVariante, quelle_id: result.quelleId}}));
                    }
                    setVarianteEditFor(null);
                }}
            />
            {!!bestellungen.length && <MaterialTable
                title="Ausgabe"
                localization={{
                    pagination: {
                        labelDisplayedRows: '{from}-{to} von {count}',
                        labelRowsPerPage: 'Zeilen pro Seite',
                        labelRowsSelect : 'Zeilen'
                    },
                    toolbar: {
                        nRowsSelected: '{0} Reihen ausgewählt',
                        searchPlaceholder: 'Suche'
                    },
                    header: {
                        actions: 'Aktionen'
                    },
                    
                    body: {
                        emptyDataSourceMessage: 'Keine Daten zum Anzeigen',
                        editRow : {
                            deleteText : 'Sicher löschen?'
                        }
                    }
                }}
                columns={[
                    { title: '', field:'edit', sorting: false, width: 50, render: rowData => {
                        const target = rowData._id ? rowData : (rowData.anzahl === 1 ? bestellungen.find(b => b.parentId === rowData.id) : null);
                        return target ? <IconButton size="small" title="Variante ändern" onClick={() => setVarianteEditFor(target)}><Edit fontSize="small"/></IconButton> : '';
                    }},
                    { title: 'Produkt', field: 'produkt' },
                    { title: 'Variante', field:'variante', render: rowData => {
                        const targetId = rowData._id || (rowData.anzahl === 1 ? bestellungen.find(b => b.parentId === rowData.id)?._id : null);
                        const planung = targetId ? variantenWechsel[targetId] : undefined;
                        const geplant = planung?.neue_variante;
                        const original = rowData.variante || '—';
                        if (geplant !== undefined && geplant !== (rowData.variante || '')) {
                            return (
                                <Box sx={{backgroundColor:'#fff3cd', padding:'2px 6px', borderRadius:'4px'}}>
                                    {original} → {geplant || '(keine)'} (geplant)
                                </Box>
                            );
                        }
                        return original === '—' ? '' : original;
                    }},
                    {title: 'Personalisierung', field:'customize',
                            hidden: !fullrows || !bestellungen.some(b => b.customize),
                            render: rowData => rowData.customize ? rowData.customize : ''},
                    {title: 'Personalisierung Farbe', field:'custom_color',
                            hidden: !fullrows || !bestellungen.some(b => b.custom_color),
                            render: rowData => rowData.custom_color ? rowData.custom_color : ''},
                    { title: 'Anzahl', field:'anzahl', render: rowData => rowData?.anzahl? rowData.anzahl : 1},
                    { title: 'Mitarbeiter', field: 'user', hidden:!fullrows,
                            render: rowData => {
                                const klar = userlabels.find(u => u.username === rowData.user);
                                return klar?.dienstplan || rowData.user || '';
                            }},
                    { title: 'Abholung durch', field: 'abholer', hidden:!fullrows,
                            render: rowData => {
                                if (!users[0] || rowData.user === users[0]) return '';
                                const klar = userlabels.find(u => u.username === users[0]);
                                return klar?.dienstplan || users[0];
                            }},
                    {title:'Bestelldatum',field:'bestelldatum',hidden:!fullrows},
                ]}
                options={{
                    selection: true,
                    search : false,
                    exportButton: true,
                    exportFileName: 'Ausgabe_'+users.join('_'),
                    pageSize: 10,
                }}
                onSelectionChange={(rows) => selectionChange(rows)}
                data={bestellungen}
                parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
                onTreeExpandChange={(e,v) => expandChange(e,v)}
            />}
        <Box sx={{margin: '10px'}}>
            <Button variant="contained" disabled={!users.length || !checkedrows.length} onClick={e => handout()}>
                Ware ausgeben an {(userlabels.find(u => u.username === users[0])?.dienstplan) || users[0] || '—'}
            </Button>
        </Box>
        <Box sx={{marginTop:'24px'}}>
            <Typography variant="h6">
                Letzte Scheine{users.length ? ` für ${userlabels.find(u => u.username === users[0])?.dienstplan || users[0]}` : ''}
            </Typography>
            {!letzteScheine.length && <Typography variant="body2" sx={{color:'#666'}}>Keine Scheine im aktuellen Filter.</Typography>}
            {!!letzteScheine.length &&
                <table className="inventur-tabelle" style={{marginTop:'8px'}}>
                    <thead>
                        <tr>
                            <th>Datum</th>
                            <th>Nr.</th>
                            <th>Mitarbeiter</th>
                            <th>Abholer</th>
                            <th>Bestellungen</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {letzteScheine.map(s => {
                            const kurzId = (s._id || '').toString().slice(0, 8);
                            const showAbholer = s.abholer && s.abholer !== s.mitarbeiter;
                            return (
                                <tr key={s._id}>
                                    <td>{s.datum}</td>
                                    <td>AS-{kurzId}</td>
                                    <td>{s.mitarbeiter_klarname || s.mitarbeiter}</td>
                                    <td>{showAbholer ? (s.abholer_klarname || s.abholer) : ''}</td>
                                    <td style={{textAlign:'center'}}>{(s.bestellung_ids || []).length}</td>
                                    <td>
                                        <Button size="small" onClick={() => druckeErneut(s._id)}>Erneut drucken</Button>
                                        <Button size="small" color="error" onClick={() => storniere(s)}>Stornieren</Button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            }
        </Box>
        </Container>
    )


    return (
        <>

            {!!bfilter.length && <MaterialTable
                title="Bestellungen"
                columns={[
                    { title: 'User', field: 'user' },
                    { title: 'Anzahl', field:'anzahl'},
                    {title: 'Abholkey',field:'abholkey'},
                    { title: 'Produkt', field: 'produkt', hidden:!fullrows },
                    { title: 'Variante', field: 'variante', hidden:!fullrows },
                    {title:'Bestelldatum',field:'bestelldatum',hidden:!fullrows}
                ]}
                options={{
                    selection: true
                }}
                onSelectionChange={(rows) => selectionChange(rows)}
                data={bfilter}
                parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
                onTreeExpandChange={(e,v) => expandChange(e,v)}
            />}
        <Button variant="contained" disabled={!checkedrows.length} onClick={e => changeStatus(3)}>markierte Einträge als abgeholt markieren</Button>
        </>
    )
}